export default __webpack_public_path__ + "static/assets/0f11418b2ebb31039d9ea96b4103c8ed.png";